import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class NotificationsIndex extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();
    }

    initEvents() {
        var requestor = new Requestor();
        var targetSelector = 'a';

        this.addEventListener('click', e => {
            let {target} = e;

            let match = target.matches(targetSelector);
            if (!match && target.parentNode && target.parentNode.matches(targetSelector)) {
                match = true;
                target = target.parentNode;
            }

            if (!match) {
                return;
            }

            var method = target.getAttribute('data-method');
            if (method) {
                e.preventDefault();
                console.log(pageParam);
                var pageParam = location.search.split('page=')[1] ? location.search.split('page=')[1] : 1;

                requestor.sendRequest(target.getAttribute('href'),
                    target.getAttribute('data-method'),
                    {'page': pageParam},
                    data => {
                        document.querySelector('.notifications-list').innerHTML = data;
                    }
                );
            }
        });
    }
}